const STORAGE_KEY = 'a360-quick-font-adjustment';

export const QUICK_FONT_MIN = -2;
export const QUICK_FONT_MAX = 6;
export const QUICK_FONT_STEP = 1;

const clamp = (value: number) =>
  Math.min(QUICK_FONT_MAX, Math.max(QUICK_FONT_MIN, Math.round(value)));

export const getQuickFontAdjustment = (): number => {
  const raw = localStorage.getItem(STORAGE_KEY);
  const parsed = raw === null ? 0 : Number(raw);
  return Number.isFinite(parsed) ? clamp(parsed) : 0;
};

export const applyQuickFontAdjustment = (value: number): number => {
  const next = clamp(value);
  localStorage.setItem(STORAGE_KEY, String(next));
  document.documentElement.style.setProperty('--ui-quick-font', `${next}px`);
  return next;
};
